import { Divider, Grid, Typography, withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import {
    ButtonCapture,
    FullWidthCheckBoxField,
    FullWidthTextField,
    GenericForm,
    WhenFieldChanges,
} from '../../../../../forms';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { OnSubmitSuccessProps } from '../../../../../workflow-navigation';
import { UpdateRules, updateRulesAction } from '../actions/override-rules';
import { Rule, RulesResult } from '../rules-reducer';
import { conditionalRequired } from '../../../../../forms/validations';
import { ClaimType } from '../../../../../claim/claim-types';
import { Nullable } from '../../../../../shared-types';

interface Props extends OnSubmitSuccessProps, StyledComponent {
    index: number;
    rules: Rule[];
    updateRules: UpdateRules;
    currentClaimType?: Nullable<ClaimType>;
}

const ResultsRulesForm = GenericForm<RulesResult>();
const resultsRulesModal: React.FunctionComponent<Props> = ({
    classes,
    index,
    rules,
    currentClaimType,
    updateRules,
    ...rest
}: Props) => {
    const onSubmit = (rulesResult: RulesResult) => {
        return updateRules(rulesResult.rules, index);
    };
    return (
        <ResultsRulesForm onSubmit={onSubmit} initialValues={{ rules: rules }} {...rest}>
            <Grid container justify="flex-start">
                <Grid item xs={12}>
                    <Typography variant="h5">Override Rules</Typography>
                    <Divider style={{ marginBottom: '16px', marginTop: '16px' }} />
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="subtitle2" className={classes.label}>
                        Rule Name
                    </Typography>
                </Grid>
                {isDeathOrFuneral() && (
                    <Grid item xs={1}>
                        <Typography variant="subtitle2" className={classes.label}>
                            Rating
                        </Typography>
                    </Grid>
                )}
                {isDeathOrFuneral() && (
                    <Grid item xs={1}>
                        <Typography variant="subtitle2" className={classes.label}>
                            Score
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={6} container>
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" className={classes.label}>
                            Override
                        </Typography>
                    </Grid>
                    <ButtonCapture>
                        <Grid item xs={10} container justify="space-between">
                            <Typography variant="subtitle2" className={classes.label}>
                                Comment
                            </Typography>
                        </Grid>
                    </ButtonCapture>
                </Grid>
                {rules.map((rule, rsIndex) => {
                    return (
                        <React.Fragment key={`rule-${rsIndex}`}>
                            <Grid item xs={4}>
                                <Typography className={classes.value}>
                                    {rule.description}
                                </Typography>
                            </Grid>
                            {isDeathOrFuneral() && (
                                <Grid item xs={1}>
                                    <Typography className={classes.value}>{rule.rating}</Typography>
                                </Grid>
                            )}
                            {isDeathOrFuneral() && (
                                <Grid item xs={1}>
                                    <Typography className={classes.value}>
                                        {rule.scoreValue}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item xs={6} container>
                                <OverrideView
                                    index={rsIndex}
                                    rating={rule.rating}
                                    currentClaimType={currentClaimType}
                                />
                            </Grid>
                        </React.Fragment>
                    );
                })}
            </Grid>
        </ResultsRulesForm>
    );

    function isDeathOrFuneral() {
        if (currentClaimType === ClaimType.Death || currentClaimType === ClaimType.Funeral) {
            return true;
        }
        return false;
    }
};
interface OverrideProps {
    index: number;
    rating?: string;
    currentClaimType: Nullable<ClaimType>;
}
const OverrideView = ({ index, rating, currentClaimType }: OverrideProps) => {
    if (rating === 'Reject') {
        return null;
    }
    return (
        <React.Fragment>
            <Grid item xs={2} container alignItems="center" style={{ marginTop: '-25px' }}>
                <FullWidthCheckBoxField name={`rules[${index}].override`} hideLabel />
                <WhenFieldChanges
                    field={`rules[${index}].override`}
                    set={`rules[${index}].comment`}
                    to={null}
                />
            </Grid>

            <ButtonCapture>
                <Grid item xs={10} style={{ marginTop: '-25px' }}>
                    <Field
                        name={`rules[${index}].override`}
                        subscription={{ value: true }}
                        component={({ input: { value: override } }) => (
                            <FullWidthTextField
                                name={`rules[${index}].comment`}
                                hideLabel
                                disabled={!override}
                                validate={conditionalRequired(isFuneralClaim)}
                                style={{ marginTop: '-4px' }}
                            />
                        )}
                    />
                </Grid>
            </ButtonCapture>
        </React.Fragment>
    );
    function isFuneralClaim() {
        return (
            currentClaimType === ClaimType.Funeral ||
            currentClaimType === ClaimType.Dread ||
            currentClaimType === ClaimType.Disability ||
            currentClaimType === ClaimType.TerminalIllness
        );
    }
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    updateRules: updateRulesAction,
};

export const ResultsRulesModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(resultsRulesModal));
